import React, { useEffect, useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import Table from '../../Components/Script/Table';
import { createUser, GetAllRole, GetAllUser, updateUser, verifyOtp } from '../../Services/userProfile';

function CreateUser() {
    const [AllUsers, setAllUsers] = useState([]);
    const [roles, setRoles] = useState([]);

    const [form, setForm] = useState({
        name: '',
        mobile:'',
        email: '',
        passwordHash: '',
        roleId: '',
        isActive: true,
        lastLogin: new Date().toISOString(),
        role: {
            id: 0,
            name: "",
            createdBy: 0
        }
    });

    const [error, setError] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [showOtpSection, setShowOtpSection] = useState(false);
    const [otp, setOtp] = useState('');
    const [currentEmail, setCurrentEmail] = useState('');
    const [isVerifying, setIsVerifying] = useState(false);

    const user = JSON.parse(localStorage.getItem("user"));

    // Password update modal
    const [selectedUser, setSelectedUser] = useState(null);
    const [newPassword, setNewPassword] = useState('');

    useEffect(() => {
        fetchAllUser();
        fetchAllRoles();
    }, []);

    const fetchAllUser = async () => {
        try {
            const data = await GetAllUser();
            setAllUsers(data);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    const fetchAllRoles = async () => {
        try {
            const rolesData = await GetAllRole();
            setRoles(rolesData);
        } catch (error) {
            console.error('Error fetching roles:', error);
        }
    };

    // Create User
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccessMsg('');

        if (!form.name || !form.email || !form.passwordHash || !form.roleId) {
            setError("All fields are required");
            return;
        }

        const formData = {
            ...form,
            createdBy: user?.id || 0,
        };

        try {
            const res = await createUser(formData);

            if (res?.message?.toLowerCase().includes("already") || res === "Email already registered") {
                setError("Email already registered");
                return;
            }

            // Show OTP section after successful creation
            setCurrentEmail(form.email);
            setShowOtpSection(true);
            setSuccessMsg(`User created successfully! OTP sent to ${form.email}`);

        } catch (err) {
            console.error('Error creating user:', err);
            setError('User creation failed. Please try again.');
        }
    };

    // Verify OTP
    const handleVerifyOtp = async () => {
        if (!otp || otp.length < 4) {
            setError("Please enter a valid OTP");
            return;
        }

        setIsVerifying(true);
        setError('');

        try {
            const payload = {
                id: 0,
                email: currentEmail,
                code: otp, // ✅ must be 'code' not 'otp'
                expiry: new Date().toISOString() // dummy (API requires it)
            };

            const res = await verifyOtp(payload);


            if (res === "Account Activated" || res === "Account Activated Successfully") {
                alert("OTP verified successfully! User is now active.");
                setShowOtpSection(false);
                setOtp('');
                setSuccessMsg('');
                fetchAllUser(); // Refresh the list

                // Reset form
                setForm({
                    name: '',
                    mobile:'',
                    email: '',
                    passwordHash: '',
                    roleId: '',
                    isActive: true,
                    lastLogin: new Date().toISOString(),
                });
            } else {
                setError(res?.message || "Invalid OTP. Please try again.");
            }
        } catch (err) {
            console.error(err);
            setError("OTP verification failed. Please try again.");
        } finally {
            setIsVerifying(false);
        }
    };

    // Send OTP for existing inactive user
    const handleSendOtpForUser = async (userItem) => {
        if (userItem.isActive) {
            alert("This user is already active.");
            return;
        }

        try {
            // You can call the same createUser API again or a separate sendOtp API
            // For now, assuming backend handles re-sending OTP when createUser is called for existing email
            await createUser({
                ...userItem,
                createdBy: user?.id || 0,
            });

            setCurrentEmail(userItem.email);
            setShowOtpSection(true);
            setOtp('');
            setSuccessMsg(`OTP sent to ${userItem.email} for activation`);
        } catch (err) {
            console.error(err);
            setError("Failed to send OTP");
        }
    };

    // Password Update
    const handleUpdatePassword = (userItem) => {
        setSelectedUser(userItem);
        setNewPassword('');
        new window.bootstrap.Modal(document.getElementById('password-update-modal')).show();
    };

    const handlePasswordUpdate = async (e) => {
        e.preventDefault();
        // if (!newPassword) {
        //     alert("Please enter a new password.");
        //     return;
        // }

        try {
            const formData = {
                userId: selectedUser.id,
                name: selectedUser.name,
                mobile: selectedUser.mobile,
                newPassword: newPassword,
            };

            await updateUser(selectedUser.id, formData);
            fetchAllUser();

            const modalElement = document.getElementById('password-update-modal');
            const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
            modalInstance?.hide();

            setNewPassword('');
            setSelectedUser(null);
        } catch (error) {
            console.error(error);
            alert('Password update failed');
        }
    };

    return (
        <div>
            <Table />

            <div className="wrapper">
                <div className="content-page">
                    <div className="content">
                        <div className="container-fluid">

                            {/* Breadcrumb & Title */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box">
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item">
                                                    <Link to="/dashboard">Dashboard</Link>
                                                </li>
                                                <li className="breadcrumb-item active">Create User</li>
                                            </ol>
                                        </div>
                                        <h4 className="page-title">Create New User</h4>
                                    </div>
                                </div>
                            </div>

                            {/* Create User Form */}
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            {error && <p className="text-danger">{error}</p>}
                                            {successMsg && <p className="text-success">{successMsg}</p>}

                                            <form onSubmit={handleSubmit}>
                                                <div className="row g-3">
                                                    <div className="col-md-4">
                                                        <label className="form-label">Full Name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter full name"
                                                            value={form.name}
                                                            onChange={(e) => setForm({ ...form, name: e.target.value })}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label className="form-label">Mobile</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Mobile"
                                                            value={form.name}
                                                            onChange={(e) => setForm({ ...form, mobile: e.target.value })}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label className="form-label">Email</label>
                                                        <input
                                                            type="email"
                                                            className="form-control"
                                                            placeholder="Enter email"
                                                            value={form.email}
                                                            onChange={(e) => setForm({ ...form, email: e.target.value })}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label className="form-label">Password</label>
                                                        <input
                                                            type="password"
                                                            className="form-control"
                                                            placeholder="Enter password"
                                                            value={form.passwordHash}
                                                            onChange={(e) => setForm({ ...form, passwordHash: e.target.value })}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label className="form-label">Role</label>
                                                        <select
                                                            className="form-control"
                                                            value={form.roleId}
                                                            onChange={(e) => setForm({ ...form, roleId: Number(e.target.value) })}
                                                            required
                                                        >
                                                            <option value="">Select Role</option>
                                                            {roles.map((role) => (
                                                                <option key={role.id} value={role.id}>
                                                                    {role.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <button type="submit" className="btn btn-primary mt-3">
                                                    Create User
                                                </button>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* OTP Verification Section */}
                            {showOtpSection && (
                                <div className="row mt-3">
                                    <div className="col-12">
                                        <div className="card border-primary">
                                            <div className="card-body">
                                                <h5 className="card-title">Enter OTP for {currentEmail}</h5>
                                                <div className="row g-3">
                                                    <div className="col-md-5">
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter OTP"
                                                            value={otp}
                                                            onChange={(e) => setOtp(e.target.value.trim())}
                                                            maxLength={6}
                                                        />
                                                    </div>
                                                    <div className="col-md-4">
                                                        <button
                                                            className="btn btn-success"
                                                            onClick={handleVerifyOtp}
                                                            disabled={isVerifying || !otp}
                                                        >
                                                            {isVerifying ? "Verifying..." : "Verify OTP"}
                                                        </button>
                                                    </div>
                                                </div>
                                                <small className="text-muted d-block mt-2">
                                                    OTP is especially required for inactive users
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Users List Table */}
                            <div className="row mt-4">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table table-striped table-bordered table-hover">
                                                    <thead>
                                                        <tr>
                                                            <th>Name</th>
                                                            <th>Mobile</th>
                                                            <th>Email</th>
                                                            {/* <th>Password</th> */}
                                                            <th>Role</th>
                                                            <th>Status</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {AllUsers.length > 0 ? (
                                                            AllUsers.map((u) => (
                                                                <tr key={u.id}>
                                                                    <td>{u.name}</td>
                                                                    <td>{u.mobile}</td>
                                                                    <td>
                                                                        {u.email}
                                                                        {!u.isActive && (
                                                                            <button
                                                                                className="btn btn-sm btn-outline-primary ms-3"
                                                                                onClick={() => handleSendOtpForUser(u)}
                                                                            >
                                                                                Send OTP
                                                                            </button>
                                                                        )}
                                                                    </td>
                                                                    {/* <td>{u.passwordHash}</td> */}
                                                                    <td>{u.role?.name || 'N/A'}</td>
                                                                    <td>
                                                                        <span className={`badge ${u.isActive ? 'bg-success' : 'bg-warning'}`}>
                                                                            {u.isActive ? 'Active' : 'Inactive'}
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        <i
                                                                            className="mdi mdi-pencil action-icon"
                                                                            onClick={() => handleUpdatePassword(u)}
                                                                            style={{ cursor: "pointer" }}
                                                                        ></i>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5" className="text-center">No Users Found</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Password Update Modal */}
                            {selectedUser && (
                                <div className="modal fade" id="password-update-modal" tabIndex="-1" aria-hidden="true">
                                    <div className="modal-dialog">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title">
                                                    Update Password for <strong>{selectedUser.name}</strong>
                                                </h5>
                                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                            </div>
                                            <div className="modal-body">
                                                <form onSubmit={handlePasswordUpdate}>
                                                    <div className="mb-3">
                                                        <label className="form-label">Name</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={selectedUser?.name || ''}
                                                            onChange={(e) =>
                                                                setSelectedUser({ ...selectedUser, name: e.target.value })
                                                            }
                                                        />
                                                    </div>

                                                    <div className="mb-3">
                                                        <label className="form-label">Mobile</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={selectedUser?.mobile || ''}
                                                            onChange={(e) =>
                                                                setSelectedUser({ ...selectedUser, mobile: e.target.value })
                                                            }
                                                        />
                                                    </div>
                                                    <div className="mb-3">
                                                        <label className="form-label">New Password</label>
                                                        <input
                                                            type="password"
                                                            className="form-control"
                                                            value={newPassword}
                                                            onChange={(e) =>
                                                                setSelectedUser({ ...selectedUser, mobile: e.target.value })
                                                            }
                                                            
                                                        />
                                                    </div>
                                                    <button type="submit" className="btn btn-primary">Update Password</button>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div>
            <Outlet />
        </div>
    );
}

export default CreateUser;